import { useEffect } from 'react';

export const withEoNumber = (WrappedComponent) => {
  return (props) => {
    const { value, setInputs } = props;
    const field = 'eo_number';

    useEffect(() => {
      return () => {
        setInputs((v) => ({
          ...v,
          [field]: value
            ? {
                value: '',
                touched: true
              }
            : undefined
        }));
      };
    }, [value]);

    return <WrappedComponent {...props} value={value} setInputs={setInputs} field={field} />;
  };
};
